import { computed, Injectable, NgZone, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthDataService } from 'src/data-store/auth-data.service';
import { UserDataService } from 'src/data-store/user-data.service';
import { AuthRoute } from 'src/models/routes.model';
import { DeviceService } from 'src/services/device.service';
import { NavigateAfterLoginService } from 'src/services/navigate-after-login.service';
import { CLIENT_REDIRECT_AFTER_AUTH_ROUTES } from 'src/util/constants';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard {
  private router = inject(Router);
  private deviceService = inject(DeviceService);
  private navigateAfterLoginService = inject(NavigateAfterLoginService);
  private authDataDataService = inject(AuthDataService);
  private userDataService = inject(UserDataService);
  private zone = inject(NgZone);

  private userAndToken = computed<boolean>(() => {
    return !!this.userDataService.loggedUser() && !!this.authDataDataService.accessToken()});

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if(!this.userAndToken() && CLIENT_REDIRECT_AFTER_AUTH_ROUTES.some(term => state.url.includes(term))) {
      // redirect on succesful auth
      this.navigateAfterLoginService.saveRouteAndAuth(state.url);
    } else if (!this.userAndToken()) {
      if(this.deviceService.isNativePlatform) {
        this.zone.run(() => {
          this.router.navigate([`/${AuthRoute.LOGIN}`]);
        });
      } else {
        this.router.navigate([`/${AuthRoute.LOGIN}`]);
      }
      return false;
    }

    return true;
  }
}
